import {Mapper} from '@s-ui/domain'

export default class FromQueryStringToQueryParamsPageMapper extends Mapper {
  constructor({parseQueryString}) {
    super({parseQueryString})

    this._parseQueryString = parseQueryString
  }

  map = ({path}) => {
    const queryParams = this._parseQueryString(path)
    return queryParams
  }
}
